// extracted by mini-css-extract-plugin
module.exports = {"tags-container":"styles_tags-container__3e5wH"};